<div class="chat-reply-container">
  <div class="chat-reply-card-container">
    <mat-card appearance="outlined" class="chat-reply-card" color="primary">
      <p class="chat-reply-card-answer">{{ message }}</p>
    </mat-card>
    <div class="chat-reply-card-submit-another-container" (click)="submitAnother()">
      <span class="chat-reply-card-submit-another">Submit another question</span>
      <mat-icon class="chat-reply-card-submit-another-icon">arrow_forward</mat-icon>
    </div>
  </div>

  <p class="chat-reply-answer-title">Manual Answer</p>
  <div class="chat-reply-answer">
    <markdown [data]="reply?.replace('<complete/>', '') ?? ''" />
  </div>

  <ng-container *ngIf="showGeneralAIFallback && !genericReply && !isGenericLoading">
    <button mat-button class="ai-web-search-button" (click)="tryGeneralAI()">
      <mat-icon>travel_explore</mat-icon>
      AI Web Search
    </button>
  </ng-container>

  <ng-container *ngIf="isGenericLoading">
    <p class="chat-reply-answer-title">AI Response</p>
    <div class="chat-reply-generic-loading">
      <mat-spinner diameter="24"></mat-spinner>
      <p>Loading AI response...</p>
    </div>
  </ng-container>

  <ng-container *ngIf="genericReply">
    <p class="chat-reply-answer-title">AI Response</p>
    <p class="chat-reply-general-ai-disclaimer">
      This response is based on general AI knowledge, not sourced from the equipment's manuals.
      Always verify critical specifications and procedures against official documentation.
    </p>
    <div class="chat-reply-answer" #genericReplyContainer>
      <markdown [data]="genericReply" (ready)="openLinksInNewTab()" />
    </div>
    <div class="safety" *ngIf="safetyGenericText">
      <p class="chat-reply-safety">
        {{ safetyGenericText }}
      </p>
    </div>
  </ng-container>

  <ng-container *ngIf="videoAnswerText">
    <mat-divider class="chat-reply-answer-source-divider"></mat-divider>
    <p class="chat-reply-answer-title">Video Answer</p>
    <div class="chat-reply-answer">
      <markdown [data]="videoAnswerText" />
    </div>
  </ng-container>

  <mat-divider class="chat-reply-answer-source-divider"></mat-divider>

  <div class="chat-reply-answer-source-file-container" *ngFor="let video of videoResources; let i = index">
    <p class="chat-reply-answer-source-file-title">Video Source {{ i + 1 | number: '2.0-0' }}:</p>
    <p class="chat-reply-answer-source-file-title">Video at timestamp {{ video.offset.split('-')[0] }}:</p>
    <mat-card appearance="outlined" class="chat-reply-answer-source-file-card" color="primary">

      <mat-icon class="chat-reply-answer-source-file-card-icon">play_circle</mat-icon>

      <div class="chat-reply-answer-source-file-card-container">
        <span class="chat-reply-answer-source-file-title">{{ video.title }}</span>
        <span class="chat-reply-answer-source-file-url"
              [class.disabled]="videoLoadingStates[i]"
              (click)="!videoLoadingStates[i] && openVideo(video.docPath, i, video.offset)">
          {{ videoLoadingStates[i] ? 'Loading...' : 'Watch Video' }}
        </span>
      </div>

    </mat-card>
    <mat-card appearance="outlined" class="chat-reply-answer-message-card" color="primary">
      <p class="chat-reply-answer-message" *ngFor="let msg of formatMessage(video.message).split('\n')">{{ msg }}</p>
    </mat-card>
  </div>

  <div class="chat-reply-answer-source-file-container" *ngFor="let resource of resources; let i = index">
    <p class="chat-reply-answer-source-file-title">Source {{ i + 1 | number: '2.0-0' }}:</p>
    <p class="chat-reply-answer-source-file-title">Please refer to the source page {{resource.page}} for following instructions:</p>
    <mat-card appearance="outlined" class="chat-reply-answer-source-file-card" color="primary">

      <mat-icon class="chat-reply-answer-source-file-card-icon">picture_as_pdf</mat-icon>

      <div class="chat-reply-answer-source-file-card-container">
        <span class="chat-reply-answer-source-file-title">{{ resource.title }}</span>
        <span class="chat-reply-answer-source-file-url" (click)="openUrl(resource.downloadUrl, resource.title, resource.page)">View Source</span>
      </div>

    </mat-card>
    <mat-card appearance="outlined" class="chat-reply-answer-message-card" color="primary">
      <p class="chat-reply-answer-message" *ngFor="let msg of formatMessage(resource.message).split('\n')">{{ msg }}</p>
    </mat-card>
  </div>

  <div class="safety" *ngIf="safetyText">
    <p class="chat-reply-safety">
      {{ safetyText }}
    </p>
  </div>

  <div class="actions">
    <h4>Actions</h4>
    <app-button [configKey]="'exportToPDF'"  [isLoading]="isLoading" (onClick)="saveReplyAsPDF()"></app-button>
    <h4>Rate This Answer</h4>
  </div>
  <app-rate-answer [transactionId]="transactionId"></app-rate-answer>


</div>
